import React from 'react';
import PropTypes from 'prop-types';
import { STAR_EMPTY_COLOR, STAR_FILL_COLOR } from '../../../constants/index';
import { StarRateSvgIcon } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';

class AdminStarRating extends React.Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    change: PropTypes.any,
    editing: PropTypes.bool,
    value: PropTypes.number
  };

  static defaultProps = {
    editing: true,
    value: 0
  };

  constructor(props) {
    super(props);
    this.state = {
      rating: 0
    }
    this.onStarClick = this.onStarClick.bind(this);
  }

  onStarClick(nextValue, prevValue, name) {
    const { change } = this.props;
    this.setState({ rating: nextValue });
    change(nextValue);
  }

  render() {
    const { rating } = this.state;
    const { className, name, editing, value } = this.props;
    return (
      <div className={className}>
        {Array.from({ length: 5 }, (elem, index) => {
          return (
            <React.Fragment key={index}>
              <StarRateSvgIcon
                color={value > index ? STAR_FILL_COLOR : STAR_EMPTY_COLOR}
                onClick={() => editing && this.onStarClick(index + 1)}
              />
            </React.Fragment>
          )
        })}
      </div>
    );
  }
}

export default AdminStarRating;